import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Card from '../atoms/Card';
import { getAppName, getLogoForTheme } from '../../services/appTheme';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Error from '../molecules/Error';
import { ErrorBoundary } from '../../services/bugsnag';
const Layout = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
    height: 100vh;
    z-index: 2;
    background-image: url('${props => props.theme.authBg}');
    background-size: cover;
    background-repeat: no-repeat;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.6);
        z-index: 1;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${props => props.theme.authBgColor};
        opacity: ${props => props.theme.overlayOpacity};
        z-index: 2;
    }
`;
const Wrapper = styled.div `
    z-index: 3;
    width: calc(100% - 30px);

    @media only screen and (min-width: 768px) {
        width: auto;
    }
`;
const StyledLogo = styled.img `
    display: block;
    margin: 0 auto 30px auto;
    width: 180px;

    @media only screen and (min-width: 768px) {
        width: 220px;
    }
`;
const AuthLayout = ({ children }) => {
    const { t } = useTranslation();
    return (_jsxs(Layout, { children: [_jsx(Helmet, { titleTemplate: '%s - ' + getAppName() }), _jsx(Wrapper, { children: _jsxs(Card, { children: [_jsx(StyledLogo, { src: getLogoForTheme(), alt: t('app_logo') }), _jsx(ErrorBoundary, { FallbackComponent: Error, children: children })] }) })] }));
};
export default AuthLayout;
